import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CommonFns from 'functions/common.ts';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import DeliveryFns from 'functions/delivery.ts';
import Big from 'big.js';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import User from 'services/user2';
import ReceiveService from 'services/receive.ts';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import ModalService from 'services/modal';

function DeliveryDelayDetail(props) {
  const Config = {
    sale: {
      apiPath: '/delayApply/getDetail',
      enumMainKey: 'B02_Acn_Status',
      companyNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Acn_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'acnXkNo'
    },
    purchase: {
      apiPath: '/vDelayApply/getDetail',
      enumMainKey: 'B02_Acn_Status',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Acn_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'acnXkNo',
      wfmCode: '1031'
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    handleMore,
    decimalPlace,
    detail,
    setDetail,
    workflow,
    self
  } = useDetail(props, config);
  const { state, dispatch } = useContext(ActionContext);
  const [lineList, setLineList] = useState([]);

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);
  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  self.afterGetDetail = function (data) {
    let list = data.lineList || [];
    list.forEach(item => {
      item.uid = item.poXkNo + item.poLineNo;
      if (
        Array.isArray(item.answerLineList) &&
        item.answerLineList.length === 1
      ) {
        item.isSingle = true;
      }
      DeliveryFns.caculateReplyQty(item);
    });
    //组装分批申请
    let cloneList = Util.clone(list);
    let replyList = [];
    let newList = [];
    let itemUidList = [];
    cloneList.forEach(item => {
      item.itemUid = item.poXkNo + item.poLineNo + item.productCode;
      if (!itemUidList.includes(item.itemUid)) {
        newList.push(item);
        itemUidList.push(item.itemUid);
      }
    });
    replyList = newList;

    cloneList.forEach((item, i) => {
      item.replyList = [];
      item.itemUid = item.poXkNo + item.poLineNo + item.productCode;
      replyList.forEach(reply => {
        if (reply.itemUid === item.itemUid) {
          if (typeof reply.diffReason === 'string' && reply.diffReason !== '') {
            reply.arrDiffReason = reply.diffReason.split(','); //B02_Answer_Diff  1单价差异，2数量差异，3交期差异
          } else {
            reply.arrDiffReason = [];
          }
          reply.replyList.push(list[i]);
        }
      });
    });

    replyList.forEach(reItem => {
      let allNoticeQty = Big(0);
      reItem.replyList.forEach(reRow => {
        allNoticeQty = allNoticeQty.plus(reRow.noticeQty);
      });
      reItem.allNoticeQty = allNoticeQty;
    });
    setLineList(replyList);
    setDetail(data);
  };

  function publish() {
    let postbody = {
      companyCode: companyCode,
      acnXkNo: self.id
    };
    ReceiveService.confirmDdaOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {self.isPurchase && (
                  <li>
                    <span className="field-label">采购方</span>
                    <div className="field-value">{detail.companyName}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">
                    {self.isPurchase ? '供应商' : '客户'}
                  </span>
                  <div className="field-value">
                    {self.isPurchase
                      ? detail.innerVendorName +
                        '(' +
                        detail.innerVendorCode +
                        ')'
                      : detail.customerName +
                        '(' +
                        detail.innerCustomerCode +
                        ')'}
                  </div>
                </li>
                <li>
                  <span className="field-label">申请单号</span>
                  <div className="field-value">{self.id}</div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">发布时间</span>
                  <div className="field-value">
                    {formatDate(detail.publishTime)}
                  </div>
                </li>
                <li>
                  <span className="field-label">发布人</span>
                  <div className="field-value">{detail.publishName}</div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('acn', detail.status)
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>产品明细</label>
          </div>
          <div className="details-item-content">
            {!Util.isEmpty(lineList) &&
              lineList.map((line, index) => (
                <div
                  className="content-line line-list-item"
                  key={String(line.id) + index}
                >
                  <div className="line-list-item-title"></div>
                  <ul className="field-list">
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{line.productCode}</div>
                    </li>
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{line.productName}</div>
                    </li>
                    <li>
                      <span className="field-label">产品规格</span>
                      <div className="field-value">{line.productScale}</div>
                    </li>
                    <li>
                      <span className="field-label">采购单号(项次)</span>
                      <div className="field-value">
                        {line.poErpNo}({line.poLineNo})
                      </div>
                    </li>
                    <li>
                      <span className="field-label">送货地址</span>
                      <div className="field-value">
                        {line.poLine?.addressInfo}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">
                        {self.isPurchase ? '待交数量' : '订单待交数量'}
                      </span>
                      <div className="field-value">
                        {formatNumber(
                          line.totalUnDeliveryQty,
                          decimalPlace.Quantity_Decimal_Place
                        )}
                      </div>
                    </li>
                    {line.isSingle && (
                      <li>
                        <span className="field-label">
                          {self.isPurchase ? '申请数量' : '排定待交数量'}
                        </span>
                        <div className="field-value">
                          {formatNumber(
                            line.allNoticeQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                        </div>
                      </li>
                    )}
                    <li>
                      <span className="field-label">审核</span>
                      <div className="field-value">
                        {line.confirmStatus === 1
                          ? '通过'
                          : line.confirmStatus === 2
                          ? '不通过'
                          : ''}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">备注</span>
                      <div className="field-value">{line.remark}</div>
                    </li>
                    {line.poLine && line.poLine.printExtendFields !== '' && (
                      <li>
                        <span className="field-label">采购说明</span>
                        <div className="field-value">
                          {line.poLine.printExtendFields}
                        </div>
                      </li>
                    )}
                  </ul>
                  {!line.replyList?.length ? (
                    ''
                  ) : (
                    <div className="order-detail-more">
                      {line.replyList?.length &&
                        line.replyList.map((item, i) => (
                          <ul key={'sub' + item.id + i} className="field-list">
                            <li>
                              <span className="field-label">申请交期</span>
                              <div className="field-value">
                                {formatDate(item.noticeExpectedDate)}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">申请数量</span>
                              <div className="field-value">
                                {formatNumber(
                                  item.noticeQty,
                                  decimalPlace.Quantity_Decimal_Place
                                )}
                              </div>
                            </li>
                          </ul>
                        ))}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>

        <div className="wrap m-flex-box fixed-bottom">
          {self.isPurchase &&
            User.checkAuth('10030402') &&
            detail.status === 1 &&
            workflow.data?.delay_delivery_apply?.complete && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认
              </Button>
            )}
        </div>
        <Modal></Modal>
      </div>
    </div>
  );
}
DeliveryDelayDetail.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(DeliveryDelayDetail);
